import { defError } from "./deferror";
export const IllegalArgumentError = defError(() => "illegal argument(s)");
export const illegalArgs = (msg) => {
    throw new IllegalArgumentError(msg);
};
